import styled from 'styled-components'

const HistorySection = styled.div`
  padding: 0px 50px;
`

export const s = { HistorySection }
